module.exports = __webpack_public_path__ + "img/aile-temelli-arabuluculuk.525b4897.jpeg";